import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountRequestsService {

  requests: Observable<any[]>;
  page: number = 1;

  constructor(firestore: AngularFirestore) {
    this.requests = firestore.collection('account-requests', ref => ref.orderBy('created', 'desc')).valueChanges({ idField: 'ID' });
  }
}
